var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBigLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.966,
    height: 18,
    viewBox: "0 0 10.966 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.681 17.631L.301 9.738a1 1 0 010-1.431L8.681.384a1.381 1.381 0 011.911 0 1.23 1.23 0 010 1.761L3.343 9.004l7.253 6.833a1.23 1.23 0 010 1.761 1.381 1.381 0 01-1.911.03z"
  })));
}
export default SvgArrowBigLeft;